module.exports = __webpack_public_path__ + "img/avatar-client.b1bbec49.png";